import { render, staticRenderFns } from "./Colors.vue?vue&type=template&id=469f1a25&scoped=true&"
import script from "./Colors.vue?vue&type=script&lang=js&"
export * from "./Colors.vue?vue&type=script&lang=js&"
import style0 from "./Colors.vue?vue&type=style&index=0&id=469f1a25&lang=scss&scoped=true&"
import style1 from "./Colors.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469f1a25",
  null
  
)

export default component.exports